export default __webpack_public_path__ + "static/Smart-Contracts-b11b1e149ab98ca4a07e4acca1e2c326.webp";